import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: "CB",
    title: "Corrugated Boxes",
    text: "Heavy-duty box solutions tailored for safe storage, transit, and industrial dispatch."
  },
  {
    icon: "AB",
    title: "Angle Boards",
    text: "Edge protection systems that improve stacking strength and reduce transit damage."
  },
  {
    icon: "PS",
    title: "PET & PP Straps",
    text: "Secure load fastening for warehouse handling, pallet movement, and shipment stability."
  },
  {
    icon: "WR",
    title: "Wrappers & Bubble Rolls",
    text: "Protective wrapping materials that keep products clean, cushioned, and presentation-ready."
  }
];

const featuredProducts = [
  "Corrugated shipping boxes",
  "Protective angle boards",
  "Industrial PET straps",
  "BOPP tapes and seals",
  "Stretch film rolls",
  "Air bubble sheets"
];

const clientLogos = ["FIEM", "SOLIDUS", "APEX", "DOLPHIN", "ICAM", "RADIANT"];

const strengths = [
  {
    title: "ISO Certified",
    text: "Quality-driven operations aligned with ISO 9001:2015 process discipline."
  },
  {
    title: "On-time Delivery",
    text: "Dedicated plant planning and logistics support for dependable dispatch schedules."
  },
  {
    title: "Custom Solutions",
    text: "Packaging built to your size, load, protection level, and branding requirements."
  }
];

function Home() {
  return (
    <div>
      <section className="hero-section section-dark">
        <div className="container hero-grid">
          <div className="hero-copy reveal">
            <p className="eyebrow">Premium Industrial Packaging</p>
            <h1>Reliable Packaging Solutions for Modern Industries</h1>
            <p className="hero-text">
              Delivering quality, durability, and innovation in every package.
            </p>
            <p className="hero-subtext">
              SAI VENKATESHWARA PACKAGES manufactures strong, custom-ready packaging materials for automotive,
              engineering, electronics, and industrial supply chains.
            </p>
            <div className="hero-actions">
              <Link to="/contact" className="btn btn-primary">
                Get Quote
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Contact Us
              </Link>
            </div>
            <div className="hero-metrics">
              <div className="metric-card">
                <strong>15+</strong>
                <span>Years of packaging expertise</span>
              </div>
              <div className="metric-card">
                <strong>2</strong>
                <span>Manufacturing plants in Hosur</span>
              </div>
              <div className="metric-card">
                <strong>ISO</strong>
                <span>Quality-focused production systems</span>
              </div>
            </div>
          </div>

          <div className="hero-panel reveal-delay">
            <div className="hero-panel-card">
              <p className="eyebrow">What We Manufacture</p>
              <ul className="feature-list">
                {featuredProducts.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="hero-badge-row">
                <span>Durable</span>
                <span>Custom Built</span>
                <span>Fast Dispatch</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-heading">
            <p className="eyebrow">Core Services</p>
            <h2>Packaging support built around industrial performance</h2>
            <p>
              Every order is designed to protect products better, streamline handling, and support consistent output.
            </p>
          </div>
          <div className="grid cards-4">
            {services.map((service, index) => (
              <article className="info-card reveal-stagger" style={{ animationDelay: `${index * 0.1}s` }} key={service.title}>
                <div className="icon-badge">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container split-layout">
          <div>
            <p className="eyebrow">Featured Products</p>
            <h2>Engineered packaging materials for demanding applications</h2>
            <p>
              From protective boxes to wrapping materials and strapping solutions, our range is designed for reliable
              industrial use and consistent product safety.
            </p>
            <Link to="/products" className="text-link">
              Explore all products
            </Link>
          </div>
          <div className="product-chip-grid">
            {featuredProducts.map((product) => (
              <div key={product} className="product-chip">
                {product}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-heading center">
            <p className="eyebrow">Clients</p>
            <h2>Trusted by industrial businesses that value consistency</h2>
          </div>
          <div className="client-logo-grid">
            {clientLogos.map((logo) => (
              <div key={logo} className="client-logo-card">
                {logo}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-accent">
        <div className="container">
          <div className="section-heading center light">
            <p className="eyebrow">Why Choose Us</p>
            <h2>A manufacturing partner that understands industrial urgency</h2>
          </div>
          <div className="grid cards-3">
            {strengths.map((item) => (
              <article key={item.title} className="contrast-card">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
